import ProductDesc from "./ProductDesc";

export default ProductDesc;
